export const courseDataDefault = {
  created_date: '',
  created_by: '',
  updated_date: '',
  updated_by: '',
  id: '',
  name: '',
  slug: '',
  description: '',
  course_type: '',
  visibility_type: '',
  join_type: '',
  echelon: '',
  start_date: null,
  end_date: null,
  max_participant: '',
  duration: '',
  image: '',
  allow_retake_quiz: false,
  tag: [],
  rating: '',
  section_list: [],
};

export const quizPlacementDataDefault = {
  created_date: '',
  created_by: '',
  updated_date: '',
  updated_by: '',
  departement_id: '',
  duration_in_seconds: '',
  allow_retake_count: null,
  passing_grade: null,
  random: null,
  id: '',
  classroom: {
    created_date: '',
    created_by: '',
    updated_date: '',
    updated_by: '',
    id: '',
    name: '',
    batch: {
      created_date: '',
      created_by: '',
      updated_date: '',
      updated_by: '',
      id: '',
      name: '',
      start_date: null,
      end_date: null,
      year: null,
    },
  },
  quizzes: [],
  unit: {
    created_date: '',
    created_by: '',
    updated_date: '',
    updated_by: '',
    id: '',
    name: '',
    description: '',
    type: '',
    file: null,
    section: {
      created_date: '',
      created_by: '',
      updated_date: '',
      updated_by: '',
      id: '',
      name: '',
      duration: null,
    },
  },
  start_date: null,
  end_date: null,
};

export const quizDataDefault = {
  created_date: '',
  created_by: '',
  updated_date: '',
  updated_by: '',
  id: '',
  name: '',
  description: '',
  departement_id: '',
  // duration: null,
  // retake_count: null,
  // passing_grade: null,
  // random: null,
  // review: null,
  // tag: [],
  question_list: {
    elements: [],
  },
  answer_list: {
    elements: [],
  },
};

export const surveyDataDefault = {
  created_date: '',
  created_by: '',
  updated_date: '',
  updated_by: '',
  id: '',
  name: '',
  description: '',
  questions: {
    elements: [],
  }
};

export const courseDetailDataDefault = {
  created_date: '',
  created_by: '',
  updated_date: '',
  updated_by: '',
  id: '',
  course: {},
  description: '',
  required_section_list: [],
  required_course_list: [],
};

export const assignmentPlacementDataDefault = {
  created_date: '',
  created_by: '',
  updated_date: '',
  updated_by: '',
  id: '',
  classroom: {
    created_date: '',
    created_by: '',
    updated_date: '',
    updated_by: '',
    id: '',
    name: '',
    batch: {
      created_date: '',
      created_by: '',
      updated_date: '',
      updated_by: '',
      id: '',
      name: '',
      start_date: null,
      end_date: null,
      year: null,
    },
  },
  assignment: [],
  unit: {
    created_date: '',
    created_by: '',
    updated_date: '',
    updated_by: '',
    id: '',
    name: '',
    description: '',
    type: '',
    file: null,
    section: {
      created_date: '',
      created_by: '',
      updated_date: '',
      updated_by: '',
      id: '',
      name: '',
      duration: null,
    },
  },
  start_date: null,
  end_date: null,
};

export const roleDefaultData = {
  created_date: '',
  created_by: '',
  updated_date: '',
  updated_by: '',
  id: '',
  name: '',
  authorities: [],
};
